import React from 'react'

import { useTranslation } from 'react-i18next'

import { useSimulacaoContentContext } from '@/features/simulacao/context/simulacao-content.context'
import { Render } from '@/shared/components/render-if'
import {
  SectionContent,
  SectionGroup,
  SectionHeader,
  SectionItem,
  SectionTitle,
  SectionItemValue,
} from '@/shared/components/ui'
import { StringUtils } from '@/shared/utils'
import { formatDateToPtBr } from '@/shared/utils/date.utils'

export const EmpreendimentoSection = () => {
  const { t } = useTranslation('simulacao')
  const { simulacao } = useSimulacaoContentContext()

  const blocoProdutoMap = {
    Lote: {
      bloco: t('pages.simulacao.empreendimento.quadra'),
      tipoDoProduto: t('pages.simulacao.empreendimento.lote'),
    },
    Unidade: {
      bloco: t('pages.simulacao.empreendimento.torre'),
      tipoDoProduto: t('pages.simulacao.empreendimento.unidade'),
    },
    Acessorio: {
      bloco: t('pages.simulacao.empreendimento.torre'),
      tipoDoProduto: t('pages.simulacao.empreendimento.acessorio'),
    },
  }

  return (
    <React.Fragment>
      <SectionHeader>
        <SectionTitle>{t('pages.simulacao.empreendimento.titulo')}</SectionTitle>
      </SectionHeader>
      <SectionContent>
        <SectionGroup withBorder>
          <SectionItem label={t('pages.simulacao.empreendimento.cliente')}>
            <SectionItemValue>{StringUtils.capitalize(simulacao.cliente.nome)}</SectionItemValue>
          </SectionItem>
        </SectionGroup>

        <SectionGroup withBorder>
          <SectionItem label={t('pages.simulacao.empreendimento.nome_empreendimento')} colSpan={4} withRightBorder>
            <SectionItemValue>{simulacao.empreendimento.nome}</SectionItemValue>
          </SectionItem>

          <SectionItem
            label={t('pages.simulacao.empreendimento.bloco_produto', {
              bloco: blocoProdutoMap[simulacao.produto.tipoDoProduto].bloco,
              tipoDoProduto: blocoProdutoMap[simulacao.produto.tipoDoProduto].tipoDoProduto,
            })}
            colSpan={4}
            withRightBorder
          >
            <SectionItemValue>
              {simulacao?.bloco.nome} - {simulacao?.produto.codigo}
            </SectionItemValue>
          </SectionItem>

          <SectionItem label={t('pages.simulacao.empreendimento.metragem')} colSpan={4}>
            <SectionItemValue>
              {t('pages.simulacao.empreendimento.metro_quadrado', {
                metragem: simulacao?.produto.metragemPrivativa,
              })}
            </SectionItemValue>
          </SectionItem>
        </SectionGroup>

        <SectionGroup>
          <Render.If condition={simulacao.produto.tipoDoProduto === 'Unidade'}>
            {() => (
              <SectionItem label={t('pages.simulacao.empreendimento.marcacao_alvenaria')} colSpan={4} withRightBorder>
                <SectionItemValue>
                  {simulacao?.produto.dataMarcacaoAlvenaria
                    ? formatDateToPtBr(simulacao.produto.dataMarcacaoAlvenaria)
                    : '-'}
                </SectionItemValue>
              </SectionItem>
            )}
          </Render.If>

          <SectionItem label={t('pages.simulacao.empreendimento.prazo')} colSpan={4} withRightBorder>
            <SectionItemValue>
              {`${simulacao.prazoEmMeses} ${StringUtils.singularPlural(simulacao.prazoEmMeses, 'mês', 'meses')}`}
            </SectionItemValue>
          </SectionItem>

          <SectionItem label={t('pages.simulacao.empreendimento.data_entrega')} colSpan={4} withRightBorder>
            <SectionItemValue>
              {simulacao?.bloco.previsaoDeEntrega ? formatDateToPtBr(simulacao?.bloco.previsaoDeEntrega) : '-'}
            </SectionItemValue>
          </SectionItem>

          <Render.If condition={simulacao.tipoDeAmortizacao === 'SacocV'}>
            {() => (
              <SectionItem label={t('pages.simulacao.empreendimento.forma_pagamento')} colSpan={4}>
                <SectionItemValue>{simulacao.formaDePagamento}</SectionItemValue>
              </SectionItem>
            )}
          </Render.If>
        </SectionGroup>
      </SectionContent>
    </React.Fragment>
  )
}
